module.exports = __webpack_public_path__ + "static/media/wim_letter_to_self.c93caeb4.gif";